export interface Operators {
  operator_id: string;
  operator_name: string;
  wallet_type: string;
  status: boolean;
}

export interface Operator {
  OperatorId: string;
  Password: string;
  Role: string;
  Status: string;
  UserId: string;
  UserKey: string;
  UserName: string;
}

export class OperatorData {
  operatorId: string;
  operatorName: string;
  operatorKey: string;
  baseURL: string;
  walletType: string;
  Status: string;
  Currency: {};
  IP: "";
  group: "";
  feedGroup: string;
  Commisssion: string;
  AddSubFields: boolean;
  betFairPlus: boolean;
  tommyPlus: boolean;
  srPlus: boolean;
  rxPlus: boolean;
  mzPlus: boolean;
  signature: boolean;
  marketResult: boolean;
  newSession: boolean;
  showBalance: boolean;
  cashout: boolean;
  betupdate: boolean;
  exposure: boolean;
  maxExposure: number;
  noCommission: boolean;
  // Integrated through the SDK: the settlement service skips the operator
  // wallet calls for these. Sent as isSdk; stored as is_sdk.
  isSdk: boolean;
  Dream: boolean;
  Tommy: boolean;
  BetFair: boolean;
  SportRadar: boolean;
  RX: boolean;
  MZ: boolean;
  version: number;
  moUrl: string;
  bmUrl: string;
  fancyUrl: string;
  premiumUrl: string;
  moTopic: string;
  bmTopic: string;
  fancyTopic: string;
  premiumTopic: string;
  betUpdatesURL: string;
  Lobby: string;
  advMO: number;
  limitId: number;
  config: {
    hold: number;
    matchOdds: { min: number; max: number; delay: number; maxOdds: number };
    bookmaker: { min: number; max: number; delay: number; maxOdds: number };
    fancy: { min: number; max: number; delay: number; maxOdds: number };
  };

  constructor(values: Object = {}) {
    //Constructor initialization
    Object.assign(this, values);
  }
}

export class PartnerData {
  "partnerId": string;
  "status": string;
  "currency": string;
  "rate": number;
  "Commisssion": number;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class DepositData {
  "OperatorId": string;
  "PartnerId": string;
  "CreditAmount": string;
  "PassKey": string;
  "Currency"?: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
export class WithdrawData {
  "OperatorId": string;
  "PartnerId": string;
  "DebitAmount": string;
  "PassKey": string;
  "Currency"?: string;
  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}
